<template>
  <Modal :value="value" @hide="hide()" :title="title">
    <div slot="body" class="content">
      <slot></slot>
      <p v-if="!mode" class="margin-top-10 has-text-weight-bold">
        Are you sure?
      </p>
    </div>
    <template slot="footer">
      <div v-if="!isLoading">
        <button
          class="button"
          :class="[
            (confirmBtn && confirmBtn.css) || {
              'is-danger': !confirmBtn || !confirmBtn.css,
            },
          ]"
          @click="confirm()"
        >
          {{ (confirmBtn && confirmBtn.text) || "Yes" }}
        </button>
        <button
          class="button"
          :class="[cancelBtn && cancelBtn.css]"
          @click="hide()"
        >
          {{ (cancelBtn && cancelBtn.Text) || "Cancel" }}
        </button>
      </div>
      <div v-show="isLoading" class="spinner-wrapper center">
        <span class="spinner is-centered"></span>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/main/Modal.vue";

export default {
  components: { Modal },
  props: {
    value: Boolean,
    title: String,
    mode: Boolean,
    confirmBtn: Object,
    cancelBtn: Object,
  },
  data() {
    return {
      show: false,
      isLoading: false,
    };
  },
  methods: {
    hide() {
      if (!this.isLoading) {
        this.$emit("hide");
      }
    },
    async confirm() {
      this.isLoading = true;
      this.$emit("confirmed", true);
    },
  },
};
</script>
